<template>
  <section class="text-gray-700 text-gray-800 font-display">
    <div class="bg-gray-100 shadow-2l overflow-hidden sm:rounded-lg">
      <div class="px-4 py-5  sm:px-6">
        <h1 class="sm:text-2xl text-3xl font-bold title-font">
          Visualizando fatura
        </h1>
        <p
          class="mt-1 max-w-2xl text-sm leading-5 text-gray-500"
        >ID: {{ this.$route.params.charge }}</p>
      </div>
    </div>
  </section>
</template>

<script>
export default {

}
</script>

<style>

</style>
